<template>
  <div class="box">
    <section class="nav_bg" v-if="imgs.length>0"></section>
    <section class="swiper_box" v-if="imgs.length>0">
      <swiper-component :imgs="imgs" cclass="swiper_h"></swiper-component>
    </section>
    <div :class="['icons',pages[0] && pages[0].length<=4?'icons_l':'']">
      <swiper :show-indicators="false">
        <swiper-slide class="swiper_item" v-for="(page,index) of pages" :key="index">
          <div @click="toPage(item)" class="icon" v-for="(item,i) of page" :key="item.desc">
            <img
              v-if="common.holidayStyle>0 &&(page.length>=10 ||page.length==5 )"
              class="icon_img_content"
              :src="require(`../../../assets/images/tabicon/holiday_${common.holidayStyle}/tabicon_${i}.png`)"
            />
            <img
              v-else-if="common.holidayStyle>0 && page.length<5"
              class="icon_img_content"
              :src="require(`../../../assets/images/tabicon/tabicon_${iconStyle}/${item.url}`)"
            />
            <img
              v-else-if="common.holidayStyle>0 &&(i<5)"
              class="icon_img_content"
              :src="require(`../../../assets/images/tabicon/holiday_${common.holidayStyle}/tabicon_${i}.png`)"
            />
            <img
              v-else-if="common.holidayStyle>0 &&(i>=5) &&page.length!=6"
              class="icon_img_content"
              :src="require(`../../../assets/images/tabicon/tabicon_${iconStyle}/${item.url}`)"
            />
            <img
              v-else-if="common.holidayStyle>0 &&(i>=5) &&page.length==6"
              class="icon_img_content"
              :src="require(`../../../assets/images/tabicon/holiday_${common.holidayStyle}/tabicon_10.png`)"
            />
            <img
              v-else
              class="icon_img_content"
              :src="require(`../../../assets/images/tabicon/tabicon_${iconStyle}/${item.url}`)"
            />
            <p class="icon_desc">{{item.text}}</p>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import swiperComponent from '../../../components/swiper'
import util from '../../../utils/util'
import {
  getPermissionByUserId,
  getIntServTemplateByMarketId,
  getTenantBuildList,
  getOfficeMaterialListByMarketId,
  getPerssionCompanyList,
  loadParkHeaderById,
  getVisitorRegByParams
} from '../../../utils/api'
export default {
  name: "indexIcons",
  components: {
    swiperComponent
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    iconStyle: {
      type: Number,
      default: 0
    },
    imgs: {
      type: Array,
      default() {
        return [];
      }
    },
    common: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {

    }
  },
  computed: {
    pages() {
      const pages = [];
      let newList = this.list.filter(item => {
        return item.show;
      });
      newList.forEach((item, index) => {
        const page = Math.floor(index / 10);
        if (!pages[page]) {
          pages[page] = [];
        }
        pages[page].push(item);
      });
      return pages;
    }
  },
  created() {
  },
  methods: {
    toPage(val) {
      if (val.text === '全部') {
        this.$router.push("/allModule")
        return;
      }
      if (val.link) {
        if (
          !this.$store.state.common.userId &&
          val.link.indexOf('emptyShopList') == -1 &&
          val.link.indexOf('BusinessLife') == -1 &&
          val.link.indexOf('policyServices') == -1 &&
          val.link.indexOf('officeService') == -1 &&
          val.link.indexOf('accessControl') == -1 &&
          val.link.indexOf('IntegralMall') == -1 && //积分商城
          val.link.indexOf('parkingService') == -1
        ) {
          this.$router.push({
            path: '/login',
            // query:{
            //   Rurl:`${val.link}`
            // }
          });
        } else {
          // 跳转网页地址
          if (val.link.indexOf("http:") > -1 || val.link.indexOf("https:") > -1) {
            //  window.location.href = val.link
            // if(val.type==4){ //直接跳转
            //    window.location.href = val.link
            // }else{  //跳转到iframe页面
              localStorage.setItem("src", val)
              this.$router.push(`/iframePage`)
            // }
            
          } else {
            if (val.link == '/comReporting') {// 企业报表
              getPermissionByUserId({ marketId: this.common.marketInfo.id, userId: this.common.userId }).then(res => {
                console.log(res)
                if (res.res.code === 10000 && res.body) {
                  if (res.body.permission && res.body.permission.indexOf("REPORT") > -1) {
                    this.$router.push(val.link);
                  } else {
                    util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                  }
                }
              })
            } else if (val.link == '/bill') { //在线账单
              getPermissionByUserId({ marketId: this.common.marketInfo.id, userId: this.common.userId }).then(res => {
                console.log(res)
                if (res.res.code === 10000 && res.body) {
                  if (res.body.permission && res.body.permission.indexOf("BILL") > -1) {
                    this.$router.push(val.link);
                  } else {
                    util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                  }
                }
              })
            } else if (val.link == '/revenueIndex') { //营收填报
              getPermissionByUserId({ marketId: this.common.marketInfo.id, userId: this.common.userId }).then(res => {
                console.log(res)
                if (res.res.code === 10000 && res.body) {
                  if (res.body.permission && res.body.permission.indexOf("REVENUE") > -1) {
                    this.$router.push(val.link);
                  } else {
                    util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                  }
                }
              })
            } else if (val.link == '/houseKeeping') { //家政服务
              getIntServTemplateByMarketId({}).then(res => {
                console.log(res);
                if (res.res.code === 10000 && res.body && res.body.intServTemplate) {
                  if (res.body.intServTemplate.length > 1) {
                    var link1 = '/houseHomePage'
                    this.$router.push(link1);
                  } else {
                    this.$router.push(val.link);
                  }
                } else {
                  util.showModal('', '项目暂未开启服务', false, '知道了', () => {

                  })
                }
              });
            } else if (val.link == '/accessControl') {
              getTenantBuildList({ 'userId': this.common.userId, 'marketId': this.common.marketInfo.id }).then(res => {
                if (res.res.code === 10000) {
                  this.$router.push(val.link);
                } else {
                  var msg = "您还没有可以使用的门禁";
                  if (res.res.msg) {
                    msg = res.res.msg;
                  }
                  util.showModal('', msg, false, '知道了', () => { })
                }
              });
            } else if (val.link == '/hpRecharge') {
              console.log("in hpRecharge")
              var params={
                 perssionVal: "RECHARGE",
                 marketId: this.common.marketInfo.id,
                 companyId:this.common.userTenantInfo.companyId,

                 userId:this.common.userId
              }
              getPerssionCompanyList(params).then(res => {
                if (res.res.code === 10000) {
                    console.log("RECHARGE")
                    this.$router.push(val.link);
                  }else{
                    util.showToast(res.res.msg)
                  }
              })


            } else if (val.link == '/officeService') {//办公耗材
              getOfficeMaterialListByMarketId({}).then(res => {
                if (res.res.code === 10000 && res.body && res.body.tbOfficeMaterials && res.body.tbOfficeMaterials.length > 0) {
                  this.$router.push(val.link);
                } else {
                  util.showModal('', '项目暂未开启服务', false, '知道了')
                }
              })
            } else if (val.link == '/parking') {//月租车
              util.showLoading()
              loadParkHeaderById({ subProjectId: this.common.marketInfo.id, url: "/parking/rstParkHeader/queryParkHeaderList" }).then(res => {
                util.hideLoading()
                if (res.res && res.res.code === 10000 && res.body && res.body.data && res.body.data.length > 0) {
                  this.$router.push(val.link);
                } else if (res.res.code !== 10004) {
                  util.showModal('', '项目暂未开启服务', false, '知道了')
                }
              })
            } else if (val.link == '/fanke') {//访客
              getVisitorRegByParams({
                userId: this.common.userId,
                marketId: this.common.marketInfo.id
              }).then(res => {
                if (res.res && res.res.code === 10003 && res.body) {
                  util.showModal(res.body.title, res.body.desc, false, '知道了')
                } else {
                  this.$router.push(val.link);
                }
              })
            } else if (val.link == '/wuyeRepair') {//物业保修
                var that =this
                var link = val.link
                if(that.common.marketInfo.id && that.common.cityId){
                    link  = link + '?marketId=' + that.common.marketInfo.id + '&cityId=' + that.common.cityId
                }else if(that.common.marketInfo.id && !that.common.cityId){
                    link = link + '?marketId=' + that.common.marketInfo.id
                }else if(!that.common.marketInfo.id && that.common.cityId){
                    link = link + '?cityId=' + that.common.cityId
                }
                this.$router.push(link);
             } else if (val.link == '/CompanyParkingPass') { //公司车位
                  getPermissionByUserId({ marketId: this.common.marketInfo.id, userId: this.common.userId }).then(res => {
                    console.log(res)
                    if (res.res.code === 10000 && res.body) {
                      if (res.body.permission && res.body.permission.indexOf("PARKMANAGER") > -1) {
                        this.$router.push(val.link);
                      } else {
                        util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                      }
                    }
                  })

            
              } else {

              this.$router.push(val.link);
            }
          }
        }
      } else {
        util.showToast('功能开发中')
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.swiper_box {
  height: 290px;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
}
.icons {
  // height: 3.64rem;
  padding-bottom: 28px;
  background: #fff;
}
.icons_l {
  height: 1.96rem;
}
.swiper_item {
  .flex();
  width: 100%;
  height: 100%;
}
.icon {
  .flex();
  flex-direction: column;
  align-items: center;
  width: 20%;
  text-align: center;
  margin-top: 28px;
  img {
    display: block;
    width: 1rem;
    height: 1rem;
    // border-radius: 100%;
    margin-bottom: 0.06rem;
  }
  .icon_desc {
    height: 0.34rem;
    font-size: 0.24rem;
    color: #333;
    line-height: 0.34rem;
    .textOver(100%);
  }
}
</style>
